import Axios from 'axios'
const API_HOST = process.env.VUE_APP_API_HOST
const API_VERSION = process.env.VUE_APP_API_VERSION

const CarouselService = {
  /**
   * @description get banners
   * @param {string} type
   *
   * @returns {object}
   */
  async getBanners(type) {
    try {
      const response = await Axios.get(`${API_HOST}/${API_VERSION}/carousel/${type}/banner`)
      return response.data.length === 1 && response.data[0].content ? response.data[0].content : null
    } catch (error) {
      console.error(error)
    }
  },
  /**
   * @description get Youtube placement videos
   * @param {string} type
   *
   * @returns {object}
   */
  async getYoutubePlacementVideos(type) {
    try {
      const response = await Axios.get(`${API_HOST}/${API_VERSION}/carousel/${type}/youtube`)
      return response.data.length === 1 && response.data[0].content ? response.data[0].content : null
    } catch (error) {
      console.error(error)
    }
  }
}

export default CarouselService
